import Project from '../model/Project'
import Image from '../model/Image'
import LemonHexa1 from '@/images/lh_dashboard_1.jpg'
import LemonHexa2 from '@/images/lh_dashboard_2.jpg'
import Ceous1 from '@/images/c_dashboard.jpg'
import Ceous2 from '@/images/c_acc.jpg'
import Ceous3 from '@/images/c_inventory.jpg'
import Ceous4 from '@/images/c_sales.jpg'
import Pathlab from '@/images/p_dashboard.png'
import Inviteman1 from '@/images/i_home.png'
import Inviteman2 from '@/images/i_dashboard.png'
import * as Technology from './Technology'

const LEMONHEXA = "lemon_hexa"
const CEOUS = "ceous"
const PATHLAB = "pathlab"
const INVITEMAN = "inviteman"

interface ProjectStruct {
    [key: string]: Project
}

const lemonHexaImages = [
    new Image(LemonHexa1),
    new Image(LemonHexa2)
];

const lemonHexaTechnologies = [
    Technology.LARAVEL,
    Technology.VUE,
    Technology.MYSQL,
]

const ceousImages = [
    new Image(Ceous1),
    new Image(Ceous2),
    new Image(Ceous3),
    new Image(Ceous4)
];

const ceousTechnologies = [
    Technology.JAVA,
    Technology.VUE,
    Technology.MYSQL
]

const pathlabImages = [
    new Image(Pathlab)
];

const pathlabTechnologies = [
    Technology.LARAVEL,
    Technology.VUE,
    Technology.MYSQL,
]

const invitemanImages = [
    new Image(Inviteman1),
    new Image(Inviteman2)
];

const invitemanTechnologies = [
    Technology.LARAVEL,
    Technology.VUE,
    Technology.MYSQL,
]

const Projects: ProjectStruct = {
    [LEMONHEXA]: new Project(lemonHexaImages, "Lemon Hexa", "Lemon Hexa is an subscription system", lemonHexaTechnologies),
    [CEOUS]: new Project(ceousImages, "Ceous", "", ceousTechnologies),
    [PATHLAB]: new Project(pathlabImages, "Pathlab", "", pathlabTechnologies),
    [INVITEMAN]: new Project(invitemanImages, "Inviteman", "", invitemanTechnologies)
}

export { LEMONHEXA, CEOUS, PATHLAB, INVITEMAN, Projects }

